module.exports = __webpack_public_path__ + "static/img/OOSH_003.830af2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/photos/OOSH_003.jpg
// module id = F+fj
// module chunks = 170